import { useQuery } from "react-query";
import { apiStripChat } from "services";
import { IGetModelsParams, IGetModelsResult } from "services/StripChatService";

const DEFAULT_OPTIONS = {
  refetchOnWindowFocus: false,
  refetchOnMount: false,
};

export const useModelsQuery = (params?: IGetModelsParams) => {
  return useQuery(["stripChatModels"], (): Promise<IGetModelsResult> => {
    return apiStripChat.getModels(params);
  }, DEFAULT_OPTIONS);
};
